<template>
  <div>
    <div class="iDownWrap">
      <div class="iDownBox">
        <div class="icon"><a href="https://itunes.apple.com/tw/app/tt-mod/id1092415991?l=zh&mt=8" title="App Store" target="_blank"><img src="../assets/images/i_download_1.png" alt="App Store"></a></div>
        <div class="icon"><a href="https://play.google.com/store/apps/details?id=com.thermaltake.t768.casemod" title="Google Play" target="_blank"><img src="../assets/images/i_download_2.png" alt="Google Play"></a></div>
      </div>
    </div>

    <div class="gSponsorsLine">
      <div class="gSponsorsWrap">
        <!-- <div class="sponsorsBox">
          <div class="ti"><p>Premium Partners</p></div>
          <div class="cont">
            <a href="http://www.newegg.com/" target="_blank" title="Newegg"><img src="images/icon_premium_1.png" alt="Newegg"></a>
          </div>
        </div> -->
        <div class="sponsorsBox">
          <div class="ti"><p>Sponsors</p></div>
          <div class="cont">
            <a v-for="sponsor in sponsors" :key="sponsor.name" :href="sponsor.link" :title="sponsor.name"><img :src="require(`../assets/images/${sponsor.img}.png`)" :alt="sponsor.name"></a>

          </div>
        </div>
        <div class="sponsorsBox">
          <div class="ti"><p>Media Partners</p></div>
          <div class="cont">
            <a v-for="partner in partners" :key="partner.name" :href="partner.link" :title="partner.name"><img :src="require(`../assets/images/${partner.img}.png`)" :alt="partner.name"></a>

          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      sponsors: [
        { name: 'Thermaltake', link: 'http://ttpremium.com/', img: 'icon_sponsors_21' },
        { name: 'ASRock', link: 'https://www.asrock.com/index.tw.asp', img: 'icon_sponsors_38' },
        { name: 'ROG STRIX', link: 'http://rog.asus.com/', img: 'icon_media_4' },
        { name: 'Seagate', link: 'http://www.seagate.com/tw/zh/internal-hard-drives/', img: 'icon_sponsors_23' },
        { name: 'Intel', link: 'http://www.intel.com/content/www/us/en/homepage.html', img: 'icon_sponsors_22' },
      ],
      partners: [
        { name: 'Modders-Inc Case Mods and Computer Hardware Reviews', link: 'http://www.modders-inc.com/', img: 'icon_sponsors_3' },
        { name: 'TweakTown | Technology content trusted worldwide', link: 'http://www.tweaktown.com/', img: 'icon_sponsors_14' },
        { name: 'Cowcotland 100% Hardware', link: 'http://www.cowcotland.com/', img: 'icon_sponsors_13' },
        { name: 'Hardwareluxx', link: 'http://www.hardwareluxx.de/', img: 'icon_sponsors_12' },
        { name: 'Back2Gaming', link: 'http://www.back2gaming.com/', img: 'icon_sponsors_20' },
        { name: 'logo', link: 'http://www.complete-tv.com/', img: 'icon_sponsors_5' },
        { name: 'eTeknix', link: 'http://www.eteknix.com/', img: 'icon_sponsors_10' },
        { name: 'GGF', link: 'http://ggflan.com/about/', img: 'icon_sponsors_1' },
        { name: 'Techguru.vn', link: 'https://www.xemgame.com/', img: 'icon_sponsors_24' },
        { name: 'Xemgame.vn', link: 'https://www.xemgame.com/', img: 'icon_sponsors_25' },
        { name: 'Tom’s Hardware', link: 'http://www.tomshardware.com/', img: 'icon_sponsors_26' },
        { name: '滄者極限', link: 'http://www.coolaler.com/content.php', img: 'icon_sponsors_27' },
        { name: 'XFastest', link: 'http://www.xfastest.com/', img: 'icon_sponsors_28' },
        { name: '泡泡网', link: 'http://www.pcpop.com/', img: 'icon_media_7' },
        { name: '天极网', link: 'http://www.yesky.com/', img: 'icon_media_8' },
        { name: '中关村在线', link: 'http://www.zol.com.cn/', img: 'icon_media_9' },
        { name: '太平洋电脑网', link: 'http://www.pconline.com.cn/', img: 'icon_media_10' },
        { name: '电脑之家', link: 'http://www.pchome.net/', img: 'icon_media_11' },
        { name: 'Kitguru', link: 'https://www.kitguru.net/', img: 'icon_sponsors_39' },
        { name: 'techpowerup', link: 'https://www.techpowerup.com/', img: 'icon_sponsors_40' },
      ]
    }
  },
  methods: {
    // getSponIcon(item) {
    //   return require(`../assets/images/${item}.png`)
    // },
  }
}
</script>
